<template>
  <v-container class="mt-3">
    <v-card>
      <v-card-title
        ><h1 class="text-h6 font-weight-bold ma-0">
          Amazon Resume Guide: How to Write a Resume That Reflects the
          Leadership Principles
        </h1></v-card-title
      >
      <v-card-text>
        <resume-cta-banner />
        <v-row>
          <v-col cols="12">
            Amazon's culture is built around its 14 Leadership Principles (LPs)
            — Customer Obsession, Ownership, Bias for Action, Deliver Results,
            Frugality, and more. They aren't just interview talking points:
            Amazon recruiters and bar raisers are trained to look for evidence
            of them starting at the resume screen. Here's how to make that
            evidence obvious.
          </v-col>
        </v-row>

        <h2 class="text-h6 mt-4 mb-2">
          1. Write Bullets That Map to a Leadership Principle
        </h2>
        <p>
          You don't need to name the principle explicitly, but every strong
          bullet should demonstrate one implicitly:
        </p>
        <ul>
          <li>
            <strong>Ownership:</strong> "Identified and fixed a recurring
            billing bug no one owned, saving $40K/quarter in refunds."
          </li>
          <li>
            <strong>Bias for Action:</strong> "Shipped an MVP fraud-detection
            rule within 5 days of the incident to stop active losses while the
            full fix was built."
          </li>
          <li>
            <strong>Deliver Results:</strong> "Hit all 6 sprint commitments over
            2 quarters while reducing defect rate by 25%."
          </li>
        </ul>

        <h2 class="text-h6 mt-4 mb-2">
          2. Lead With the Metric, Not the Activity
        </h2>
        <p>
          Amazon is famously data-driven — internal documents are written as
          narratives backed by numbers, not slide decks. Your resume should
          follow the same instinct: put the measurable outcome first, then
          briefly explain how you got there.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          3. Show Customer Obsession, Even in Backend Roles
        </h2>
        <p>
          "Customer" doesn't have to mean an end user — it can be an internal
          team, a downstream service, or a business partner. If your work
          reduced customer-facing errors, support tickets, or latency that users
          experienced, say so directly.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          4. Demonstrate Frugality and Efficiency
        </h2>
        <p>
          Cost savings, infrastructure reduction, and "doing more with less"
          resonate strongly at Amazon. If you reduced spend, consolidated tools,
          or simplified a process, quantify it — Amazon reviewers respond well
          to dollar figures and percentage reductions.
        </p>

        <h2 class="text-h6 mt-4 mb-2">
          5. Keep the Format Plain and Scannable
        </h2>
        <p>
          Amazon's ATS and recruiter screens favor simple, single-column resumes
          with standard section headers. Save the creative formatting for your
          portfolio, not your resume.
        </p>

        <v-alert type="info" outlined class="mt-4">
          Tip: Also see our
          <router-link to="/faang-resume-guide">FAANG resume guide</router-link>
          for patterns that apply broadly, or our
          <router-link to="/tech-startup-resume-guide"
            >tech startup resume guide</router-link
          >
          if you're weighing Amazon against an early-stage company.
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ResumeCtaBanner from "../../components/ResumeCtaBanner.vue";

export default {
  name: "AmazonResumeGuide",
  components: { ResumeCtaBanner },
  mounted() {
    this.$utils.visit(this);
  },
};
</script>
